<template>
  <div class="switch-student-dialog-body" :class="{'scrolling-style': isScrolling}">
    <div id="students-list-wrapper" class="students-list-wrapper" @scroll="watchScroll">
      <div v-if="switchStuTipText" class="coupon-tip-container">
        <div class="coupon-tip font-medium">
          <i class="iconfont icon-alert" /><span>{{ switchStuTipText }}</span>
        </div>
      </div>
      <div v-if="!isAppli" class="students-list-title font-medium">
        <!-- {{ $t('login.switchStudent.phoneNumTip', [userInfo.countryCallingCode, userInfo.phone || encryptPhone]) }} -->
        {{ $t('login.switchStudent.dialogTip') }}
      </div>

      <div class="students-list" :class="{'is-appli': isAppli}">
        <template v-if="isLoading">
          <Loading :show="isLoading" :margin-top="0" :margin-bottom="0" />
        </template>
        <template v-else>
          <div v-for="(student, index) in studentsList" :key="index" @click="selectStudentHandler(student.uid, student)">
            <StudentItemCard :student-info="student" :can-selected="true" :class="{selected: student.uid === currentSelectedStudentId}">
              <!-- <template v-if="studentsList.length === 1 && !nickNameModified" v-slot:stu-name>
                <span>
                  {{ $t('login.switchStudent.currentStudent') }}
                </span>
              </template> -->
            </StudentItemCard>
          </div>
        </template>
      </div>
      <template v-if="studentsList.length === 1 && !isComleteInfo && !isAppli">
        <div class="guide-to-add-student font-medium">
          {{ $t('login.switchStudent.addTip[3]') }}
        </div>
      </template>
      <template v-else-if="studentsList.length < 6 && studentsList.length >= 1">
        <div class="guide-to-add-student font-medium">
          {{ $t('login.switchStudent.addTip[0]') }}<span class="btn-add-student" @click="addStudentHandler">{{ $t('login.switchStudent.addTip[1]') }}</span>{{ $t('login.switchStudent.addTip[2]') }}
        </div>
      </template>
    </div>

    <button :disabled="isSubmiting" class="button button-normal button-continue" @click="confirmSelectedStudent">
      {{ continueButtonText }}
    </button>
  </div>
</template>

<script>
import bus from 'common/bus';
import { oneApi } from 'config/api';
import { setCookies } from 'common/utils'
import Loading from 'components/common/Loading';
import StudentItemCard from 'components/myAccount/StudentItemCard/index.vue';

const throttle = require('lodash/throttle');

export default {
  components: { Loading, StudentItemCard },
  props: {
    isAddCart: {
      default: false,
      type: Boolean,
    },
    switchStuTipText: {
      default: '',
      type: String,
    },
    studentInfo: {
      type: Array,
    },
    isAppli: {
      default: false,
      tyrp: Boolean,
    },
  },
  data() {
    return {
      isScrolling: false,
      isLoading: false,
      isSubmiting: false,
      studentsList: [],
      currentStudentId: '',
      currentSelectedStudentId: '',
      studentsListBodyScrollTop: 0,
      nickNameModified: true,
      currentSelectedStudentInfo: null,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.ucenter.user
    },
    isComleteInfo() {
      return this.$store.state.ucenter.isComleteInfo
    },
    continueButtonText() {
      if (this.isAddCart) {
        return this.$t('order.shoppingCart.addToCart')
      }
      if (this.isAppli) {
        return this.$t('page.application.registerNow')
      }
      return this.$t('login.switchStudent.continueSignUp')
    },
  },
  watch: {
    studentsListBodyScrollTop(newVal) {
      const that = this;
      setTimeout(() => {
        if (newVal > 0) {
          that.isScrolling = true;
        } else {
          that.isScrolling = false;
        }
      }, 100)
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.getStudentsList();
    if (this.studentsList.length === 1) {
      await this.setNickNameModify()
    }
    this.isLoading = false;

    bus.$on('switchStudent.refresh', (newUid) => {
      this.refresh(newUid)
    })
  },
  methods: {
    watchScroll: throttle(function watchScrollTop() {
      const ele = document.getElementById('students-list-wrapper');
      this.studentsListBodyScrollTop = ele.scrollTop;
    }),
    async refresh(newUid) {
      this.selectStudentHandler(newUid);
      await this.getStudentsList();
    },
    // 选择学员
    selectStudentHandler(uid, studentInfo) {
      this.currentSelectedStudentId = uid;
      this.currentSelectedStudentInfo = studentInfo;
    },
    // 确认已选学员
    async confirmSelectedStudent() {
      if (this.currentSelectedStudentId !== this.currentStudentId) {
        await this.handleSwitchStudent();
        return;
      }
      // 触发报名校验方法
      this.$emit('switch-success', false, this.currentSelectedStudentInfo)
    },
    async handleSwitchStudent() {
      if (this.isSubmiting) return;
      this.isSubmiting = true;
      const data = {
        targetUid: this.currentSelectedStudentId,
      }
      const res = await this.$axios.post(oneApi.switchAccount, data, { rewritePostBody: true });

      if (Number(res.code) !== 0) {
        this.$ElMessage.error(res.msg);
        this.isSubmiting = false;
        return
      }
      const resData = res.data || {};
      this.$store.commit('ucenter/SET_USER', resData)

      this.isSubmiting = false;
      this.switchStudentSuccessHandler(resData);

      // 触发报名校验方法
      this.$emit('switch-success', true, this.currentSelectedStudentInfo)
    },
    async switchStudentSuccessHandler(resData) {
      const accessToken = resData.unifiedAccessToken || '';

      if (!accessToken) {
        this.$ElMessage.error('Switch Account Failed!');
        return;
      }
      // 设置Cookie
      setCookies('_official_token', accessToken)

      // 更新用户信息
      await this.$store.dispatch('ucenter/queryUserBasicInfo', { $axios: this.$axios, userData: { fillInAttention: false } });
      // 神策-用户登录
      this.Sensors.login(this.$store.state.ucenter.user.uid)

      // 重置当前学员Id
      this.currentStudentId = resData.uid;
    },
    /**
     * 添加学员方法
     */
    addStudentHandler() {
      this.$emit('add-student');
    },
    async getStudentsList() {
      const res = await this.$axios.post(oneApi.getFamilyStudentsList, {}, { rewritePostBody: true });
      if (Number(res.code) !== 0) {
        this.isLoading = false;
        this.$ElMessage({
          type: 'error',
          message: res.msg,
        });
        return
      }
      const resData = res.data || {};
      this.studentsList = resData.associatedAccount || [];
      // 添加当前登录学员
      this.studentsList.unshift(resData.currentAccount);
      this.studentsList.sort((one, next) => one.uid - next.uid)
      // 设置当前学员id
      this.currentStudentId = resData.currentAccount.uid;

      let firstName = ''
      let lastName = ''

      if (this.studentInfo && this.studentInfo.length > 0) {
        this.studentInfo.forEach((e) => {
          if (e.key === 'givenName') {
            firstName = e.value
          }
          if (e.key === 'familyName') {
            lastName = e.value
          }
        })
      }

      this.currentSelectedStudentId = resData.currentAccount.uid;

      this.studentsList.forEach((e) => {
        if (e.firstName === firstName && e.lastName === lastName) {
          this.currentSelectedStudentId = e.uid
        }
      })

      this.$store.commit('ucenter/SET_ASSOCIATED_ACCOUNTS', resData.associatedAccount.length || 0)
      if (!this.currentSelectedStudentInfo) {
        // eslint-disable-next-line
        this.currentSelectedStudentInfo = this.studentsList.filter(item => item.uid === this.currentSelectedStudentId)[0];
      }
    },
    async setNickNameModify() {
      const res = await this.$axios.post(oneApi.queryUserNickname, {}, { rewritePostBody: true });
      if (Number(res.code) !== 0) {
        this.$ElMessage({
          type: 'error',
          message: res.msg,
        });
      }
      const resData = res.data || {};
      this.nickNameModified = resData.nickNameModified
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog.common-dialog .el-dialog__body .dialog-body {
  padding-top: 0;
}

.switch-student-dialog-body {
  padding: 0 0 20px;
  width: 512px;
  max-height: 564px;
  overflow: auto;

  &.scrolling-style {
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 30px;
      border-radius: 10px 10px 0 0;
      background: linear-gradient(180deg, rgba(222, 226, 231, 0.6) 0%, rgba(222, 226, 231, 0) 100%);
    }
  }

  .coupon-tip {
    margin: 0 auto;
    padding: 8px 20px;
    width: 380px;
    font-size: 12px;
    line-height: 14px;
    color: var(--txt-color-link);
    border-radius: 1000px;
    background: #fff;

    i,
    span {
      display: inline-block;
      vertical-align: middle;
    }

    .icon-alert {
      font-size: 18px;
    }

    span {
      margin-left: 10px;
      width: 305px;
      word-break: keep-all;
    }
  }

  .guide-to-add-student,
  .students-list-title {
    font-size: 16px;
    line-height: 19px;
    color: var(--txt-color-lv2);
    // word-break: keep-all;
  }

  .guide-to-add-student {
    margin: 20px 0 0;

    .btn-add-student {
      color: var(--txt-color-link);
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .students-list-wrapper {
    padding: 0 66px;
    max-height: 434px;
    overflow: auto;

    .students-list-title {
      margin: 34px 0 20px;
    }
    .is-appli {
      margin-top: 34px;
    }

    .students-list {
      min-height: 86px;

      /deep/.loading-wrapper {
        height: 86px;
      }
    }

    /deep/.student-item-card-wrapper {
      margin: 2px auto;
      border-radius: 0;

      &:first-child {
        border-radius: 10px 10px 0 0;
      }

      &:last-child {
        border-radius: 0 0 10px 10px;
      }

      &:only-child {
        border-radius: 10px;
      }
    }
  }

  .button-continue {
    margin: 24px auto 0;
  }
}
</style>
